"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireWildcard(require("./Icon"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizesInPx = {
  medium: 32,
  small: 24
};
var paddingInPx = {
  medium: 6,
  small: 2
};

var buildStyles = function buildStyles(_ref) {
  var size = _ref.size,
      color = _ref.color,
      _ref$theme = _ref.theme,
      typography = _ref$theme.typography,
      palette = _ref$theme.palette;
  // Predefined values
  var themePalette = palette[color];
  var colors = {
    background: themePalette.main,
    hover: themePalette.light,
    active: themePalette.dark,
    disabled: palette.grey[300],
    color: themePalette.contrastText
  };
  return (0, _styledComponents.css)(["width:", ";height:", ";border-radius:50%;border:0;color:", ";padding:", ";background-color:", ";&:hover{background-color:", ";}&:active{background-color:", ";}&.Mui-disabled{background-color:", ";}"], typography.pxToRem(sizesInPx[size]), typography.pxToRem(sizesInPx[size]), colors.contrastText, typography.pxToRem(paddingInPx[size]), colors.background, colors.hover, colors.active, colors.disabled);
};

var IconButtonBase = /*#__PURE__*/(0, _styledComponents["default"])(_IconButton["default"]).withConfig({
  displayName: "IconButton__IconButtonBase"
})(["", ""], buildStyles);

var IconButton = _react["default"].forwardRef(function (_ref2, ref) {
  var icon = _ref2.icon,
      iconColor = _ref2.iconColor,
      size = _ref2.size,
      iconProps = _ref2.iconProps,
      rest = _objectWithoutProperties(_ref2, ["icon", "iconColor", "size", "iconProps"]);

  return _react["default"].createElement(IconButtonBase, _extends({}, rest, {
    size: size,
    ref: ref
  }), _react["default"].createElement(_Icon["default"], _extends({
    icon: icon,
    fontSize: _Icon.iconSizesInPx[size] ? size : 'default',
    customColor: iconColor,
    buttonColor: rest.color
  }, iconProps)));
});

IconButton.propTypes = {
  icon: _propTypes["default"].string.isRequired,
  size: _propTypes["default"].oneOf(Object.keys(sizesInPx)),
  iconColor: _propTypes["default"].string,
  iconProps: _propTypes["default"].object
};
IconButton.defaultProps = {
  size: 'medium',
  color: 'secondary',
  variant: 'contained',
  iconProps: {}
};
var _default = IconButton;
exports["default"] = _default;